export default () => ({
  nextPageButtonContainer: {
    paddingBottom: '1em',
    marginTop: '1em',
  },
  center: {
    textAlign: 'center',
    margin: '1em',
  },
  viewContainer: { marginRight: 58 },
  button: { margin: 8 },
  nextPageProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});
